import React from 'react';
import { DocumentType } from './DocumentItemTypes';
import { getConfig } from 'config/config';

import { IonIcon } from 'components/UI/IonIcon';
import PdfFileIcon from 'assets/icons/PdfFileIcon';
import audioIcon from '../../../../assets/icons/AudioIcon.png';
import Video from 'react-player';

const { theme } = getConfig();

export const FileIcon: React.FC<{ fileExtention: string; document: DocumentType }> = React.memo(
  ({ fileExtention, document }) => {
    if (fileExtention === 'image') {
      return (
        <img
          loading="lazy"
          alt={document.filename}
          src={document.thumb || document.path}
          style={{ width: 40, height: 40 }}
        />
      );
    }
    if (fileExtention === 'pdf') {
      if (document.thumb)
        return <img loading="lazy" alt="PDF" src={document.thumb} style={{ width: 40, height: 40 }} />;
      else return <PdfFileIcon fill={theme.BUTTON_ICON} />;
    }
    if (fileExtention === 'video') {
      if (document.mimetype?.includes('audio') || !document.thumb)
        return (
          <img loading="lazy" alt="audio" src={audioIcon} style={{ width: 30, height: 30, alignSelf: 'center' }} />
        );
      if (document.thumb)
        return <img loading="lazy" alt="video" src={document.thumb} style={{ width: 40, height: 40 }} />;
      // Fallback to react-player for video playback
      return <Video url={document.path} width={40} height={40} playing={false} />;
    }
    if (fileExtention === 'file') {
      return <IonIcon name="document-outline" size={40} />;
    }
    return <div>{fileExtention}</div>;
  },
);
